import { prettyName } from '@src/utils/string';
import type { ReactNode } from 'react';
import type { EntityAdminRecord } from '../../types';
import { isOptionDivider } from './components/dividerUtils';
import type { InputsAndDropdownsDrawerOption } from './types';

/**
 * Resolves the label for a drawer option, handling function-based titles and appending required asterisk.
 * Supports both string and ReactNode title types.
 */
export function getOptionLabel<TDrawerRecord extends EntityAdminRecord>(
  option: InputsAndDropdownsDrawerOption<TDrawerRecord>,
  form: TDrawerRecord
): ReactNode {
  if (isOptionDivider(option)) {
    return null;
  }
  const titleValue = typeof option.title === 'function' ? option.title(form) : option.title;
  const baseLabel = titleValue || prettyName(String(option.field));
  const requiredSuffix = option.getIsRequired?.(form) ? '*' : '';

  // If title is a ReactNode (not a string), we need to handle it differently
  if (typeof baseLabel === 'string') {
    return `${baseLabel}${requiredSuffix}`;
  }

  // For ReactNode titles, append required suffix as a string
  return (
    <>
      {baseLabel}
      {requiredSuffix}
    </>
  );
}
